import { Translate } from '~/i18n';
import Container from '../common/container';
import { TypesFilters } from './type-filters';
import { AdvancedFilters } from './advanced-filters';
import { Region } from '../home-page/cities-slider';
import { FilterCategory } from '~/interfaces/filters';
import { FiltersSort } from './advanced-filters/sort';
import { FiltersLoading } from './loader';
import { FiltersSearchForm } from './search-form';

interface FiltersPageLayoutProps {
   children: React.ReactNode;
   regions: Region[];
   categories: FilterCategory[];
   experiencesCount?: number;
   eventsCount?: number;
}
export const FiltersPageLayout = ({
   children,
   regions,
   categories,
   eventsCount,
   experiencesCount,
}: FiltersPageLayoutProps) => {
   return (
      <div>
         <FiltersLoading />
         <section
            className="relative mt-16 bg-no-repeat bg-cover h-36 tablet:mt-0"
            style={{ backgroundImage: 'url("/images/common/colored-bg.jpg")' }}>
            <Container className="flex items-center h-full font-bold">
               <div className="flex items-center justify-between w-full">
                  <h1 className="leading-none tracking-tight text-white text-double">
                     <Translate id="filters:things to do" />
                  </h1>
                  <FiltersSearchForm />
               </div>
            </Container>
         </section>
         <div className="min-h-[600px]">
            <TypesFilters eventsCount={eventsCount} experiencesCount={experiencesCount} />
            <Container className="xl:!px-0">
               <div className="px-0 pt-5 mx-auto tablet:pt-7 tablet:grid tablet:grid-cols-4">
                  <div className="tablet:col-span-1">
                     <AdvancedFilters regions={regions} categories={categories} />
                  </div>
                  <div className="col-span-3 tablet:rtl:mr-[23px] tablet:ltr:ml-[23px]">
                     <Container className="tablet:ltr:!pr-0 tablet:rtl:!pl-0">
                        <FiltersSort />
                        {children}
                     </Container>
                  </div>
               </div>
            </Container>
         </div>
      </div>
   );
};
